import { Box, LinkCard } from '@bymason-private/legacy-pattern-components';

interface NoNotificationsProps {
  onShowCreateNotificationModal: () => void;
}

export default function NoNotifications({ onShowCreateNotificationModal }: NoNotificationsProps) {
  return (
    <Box sx={{ width: '100%', paddingTop: 6, display: 'flex', justifyContent: 'center', gap: 3 }}>
      <LinkCard
        message='Create notification rule'
        Component={
          <img
            src='https://mcdn.bymason.com/runway/controller/empty-state-groups.svg'
            alt='Make groups to organize and categorize your devices'
            width='160'
          />
        }
        onClick={onShowCreateNotificationModal}
      />
      <LinkCard
        message='View documentation'
        Component={
          <img
            src='https://mcdn.bymason.com/runway/controller/empty-state-docs.svg'
            alt='Visit our documentation site'
          />
        }
        href='https://docs.bymason.com/api/fleet'
        target='_blank'
        rel='noopener noreferrer'
      />
    </Box>
  );
}
